import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { Card, CardMedia, Typography} from '@mui/material';
import { getEntityImageUrl } from '../../../../api/utils'
import {  AvatarContainer } from './styled';
import { defaultVenueImage } from '../../../../assets/images/defaults';

const VenueListItem = ({ venue, selectVenue }) => {

  const handleImageRenderError = (e) => {
    e.target.src = defaultVenueImage
  }

  return (
    <div onClick={() => selectVenue(venue)} style={{ cursor: 'pointer', position: 'relative' }}>
      <Card style={{ position: 'relative' }}>
        <AvatarContainer>
          <CardMedia
            component="img"
            src={getEntityImageUrl(venue, 'thumbnail', defaultVenueImage)}
            alt="Participant Image"
            onError={handleImageRenderError}
            sx={{ borderRadius: '10px' }}
          />
        </AvatarContainer>
        <Grid container spacing={1} alignItems="center" justifyContent="center">
          <Grid item xs={9}>
            <Typography sx={{ marginTop: '4px', paddingLeft: '6px', fontSize: '16px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {venue?.name}
            </Typography>
          </Grid>
          <Grid item xs={3}>

          </Grid>
        </Grid>

      </Card>
    </div>
  );
};

VenueListItem.propTypes = {
  venue: PropTypes.object,
  selectVenue: PropTypes.func,
}

export default VenueListItem
